(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["complementary-products"] && !Shopify.designMode) return;
  try {
    window.listCarouselNav = function(direction, btn) {
    var container = btn.closest('complementary-products') || btn.closest('product-recommendations') || btn.closest('.block-resource-list');
    if (!container) return;

    var carousel = container.querySelector('[data-list-carousel]');
    if (!carousel) return;

    var slides = carousel.querySelectorAll('[data-list-carousel-slide]');
    var slideCount = slides.length;
    var currentIndex = parseInt(carousel.getAttribute('data-current-index') || '0', 10);

    if (direction === 'prev' && currentIndex > 0) {
      currentIndex--;
    } else if (direction === 'next' && currentIndex < slideCount - 1) {
      currentIndex++;
    }

    carousel.setAttribute('data-current-index', currentIndex);

    var track = carousel.querySelector('[data-list-carousel-track]');
    if (track) {
      track.style.transform = 'translateX(-' + (currentIndex * 100) + '%)';
    }

    var prevBtn = container.querySelector('[data-list-carousel-prev]');
    var nextBtn = container.querySelector('[data-list-carousel-next]');
    if (prevBtn) prevBtn.disabled = currentIndex === 0;
    if (nextBtn) nextBtn.disabled = currentIndex >= slideCount - 1;
  };

  window.listCarouselAddToCart = function(btn) {
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    var originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding...';

    var cartItemsEl = document.querySelector('cart-items-component[data-section-id]');
    var cartSectionId = cartItemsEl ? cartItemsEl.getAttribute('data-section-id') : null;

    var body = { items: [{ id: parseInt(variantId, 10), quantity: 1 }] };
    if (cartSectionId) {
      body.sections = cartSectionId;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
    .then(function(r) { return r.json(); })
    .then(function(response) {
      btn.textContent = 'Added!';

      var eventDetail = {
        resource: response,
        sourceId: variantId,
        data: {
          source: 'list-carousel',
          sections: response.sections || {}
        }
      };
      document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: eventDetail }));

      var cartDrawer = document.querySelector('cart-drawer-component');
      if (cartDrawer && cartDrawer.open) cartDrawer.open();
      setTimeout(function() { btn.textContent = originalText; btn.disabled = false; }, 1500);
    })
    .catch(function() {
      btn.textContent = 'Error';
      setTimeout(function() { btn.textContent = originalText; btn.disabled = false; }, 1500);
    });
  };
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-recommendations"] && !Shopify.designMode) return;
  try {
    // List Carousel Navigation (per-carousel state via data attributes)
  window.listCarouselNav = function(direction, btn) {
    var container = btn.closest('product-recommendations') || btn.closest('.block-resource-list');
    if (!container) return;

    var carousel = container.querySelector('[data-list-carousel]');
    if (!carousel) return;

    var track = carousel.querySelector('[data-list-carousel-track]');
    var slides = carousel.querySelectorAll('[data-list-carousel-slide]');
    var slideCount = slides.length;
    var currentIndex = parseInt(carousel.getAttribute('data-current-index') || '0', 10);

    if (direction === 'prev' && currentIndex > 0) {
      currentIndex--;
    } else if (direction === 'next' && currentIndex < slideCount - 1) {
      currentIndex++;
    }

    carousel.setAttribute('data-current-index', currentIndex);

    if (track) {
      track.style.transform = 'translateX(-' + (currentIndex * 100) + '%)';
    }

    var prevBtn = container.querySelector('[data-list-carousel-prev]');
    var nextBtn = container.querySelector('[data-list-carousel-next]');
    if (prevBtn) prevBtn.disabled = currentIndex === 0;
    if (nextBtn) nextBtn.disabled = currentIndex >= slideCount - 1;
  };

  window.listCarouselInit = function(container) {
    if (!container) return;

    var carousel = container.querySelector('[data-list-carousel]');
    if (!carousel) return;

    var slides = carousel.querySelectorAll('[data-list-carousel-slide]');
    var nav = container.querySelector('[data-list-carousel-header-nav]');

    // Hide arrows if only 1 slide (or none)
    if (nav) {
      nav.style.display = slides.length <= 1 ? 'none' : '';
    }

    // Reset carousel state
    carousel.setAttribute('data-current-index', '0');
    var track = carousel.querySelector('[data-list-carousel-track]');
    if (track) {
      track.style.transform = 'translateX(0%)';
    }

    var prevBtn = container.querySelector('[data-list-carousel-prev]');
    var nextBtn = container.querySelector('[data-list-carousel-next]');
    if (prevBtn) prevBtn.disabled = true;
    if (nextBtn) nextBtn.disabled = slides.length <= 1;
  };

  window.listCarouselAddToCart = function(btn) {
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    var originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding...';

    /* Find the cart section ID so we can request updated HTML */
    var cartItemsEl = document.querySelector('cart-items-component[data-section-id]');
    var cartSectionId = cartItemsEl ? cartItemsEl.getAttribute('data-section-id') : null;

    var body = { items: [{ id: parseInt(variantId, 10), quantity: 1 }] };
    if (cartSectionId) {
      body.sections = cartSectionId;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
    .then(function(r) { return r.json(); })
    .then(function(response) {
      btn.textContent = 'Added!';

      var eventDetail = {
        resource: response,
        sourceId: variantId,
        data: {
          source: 'list-carousel',
          sections: response.sections || {}
        }
      };
      document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: eventDetail }));

      var cartDrawer = document.querySelector('cart-drawer-component');
      if (cartDrawer && cartDrawer.open) cartDrawer.open();
      setTimeout(function() { btn.textContent = originalText; btn.disabled = false; }, 1500);
    })
    .catch(function() {
      btn.textContent = 'Error';
      setTimeout(function() { btn.textContent = originalText; btn.disabled = false; }, 1500);
    });
  };
  } catch(e) { console.error(e); }
})();

})();
